import useClientInstallationData from 'modules/client-installation/hooks/useClientInstallationData';
import { useParams } from 'react-router-dom';
import UpdateClientInstallationForm from '../UpdateClientInstallationForm/UpdateClientInstallationForm';
import { LinearProgress } from '@library/loaders/components';

const ClientInstallationDetails = () => {
    const { clientInstallationId } = useParams();
    const { clientInstallation, isLoading, setData } = useClientInstallationData(clientInstallationId);
    return (
        <div>
            {isLoading ? (
                <>
                    <LinearProgress />
                </>
            ) : (
                <div>
                    <UpdateClientInstallationForm initialData={clientInstallation} setData={setData} />
                </div>
            )}
        </div>
    );
};

export default ClientInstallationDetails;
